import { render, staticRenderFns } from "./IndexComponent.vue?vue&type=template&id=1d581b24"
import script from "./IndexComponent.vue?vue&type=script&lang=js"
export * from "./IndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d581b24')) {
      api.createRecord('1d581b24', component.options)
    } else {
      api.reload('1d581b24', component.options)
    }
    module.hot.accept("./IndexComponent.vue?vue&type=template&id=1d581b24", function () {
      api.rerender('1d581b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paging/IndexComponent.vue"
export default component.exports